import script from "./CollapsePanels.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapsePanels.vue?vue&type=script&setup=true&lang=js"

import "./CollapsePanels.vue?vue&type=style&index=0&id=608c4944&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-608c4944"]])

export default __exports__